import { useRecoilValue } from "recoil";
import { settingsMenuAtom } from "../../atoms/settingsMenuAtom";
import styles from "./SettingsMenu.module.css";
import { useEffect, useState } from "react";
import sounds from "../../classes/Sounds";
import { DEFAULT_MUSIC_VOLUME, DEFAULT_SFX_VOLUME } from "../../helpers/consts";

export default function SettingsMenu() {
  // Track local state for UI

  const [musicVolume, setMusicVolume] = useState(sounds.musicVolume);
  const [sfxVolume, setSfxVolume] = useState(sounds.sfxVolume);

  // Sync values to sound manager
  useEffect(() => {
    sounds.setMusicVolume(musicVolume);
  }, [musicVolume]);
  useEffect(() => {
    sounds.setSfxVolume(sfxVolume);
  }, [sfxVolume]);

  // Show according to Atom
  const isSettingsMenuOpen = useRecoilValue(settingsMenuAtom);
  if (!isSettingsMenuOpen) {
    return null;
  }

  return (
    <div className={styles.settingsMenu}>
      <h2>Settings</h2>

      <label>
        <span className={"label-text"}>Music Volume</span>
        <input
          type="range"
          max={DEFAULT_MUSIC_VOLUME}
          min={0}
          step={0.05}
          value={musicVolume}
          onChange={(e) => {
            setMusicVolume(e.target.valueAsNumber);
          }}
        />
      </label>
      <label>
        <span className={"label-text"}>SFX Volume</span>
        <input
          type="range"
          max={DEFAULT_SFX_VOLUME}
          min={0}
          step={0.1}
          value={sfxVolume}
          onChange={(e) => {
            setSfxVolume(e.target.valueAsNumber);
          }}
        />
      </label>
    </div>
  );
}
